module.exports = __webpack_public_path__ + "static/decorative_dont-1c66e03a85a0c8792cab9856431bbe84.png";